import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="12 0 40 64" {...props}>
    <path d="M12.5 32L44.5 0L51 6.5L25.5 32L51 57.5L44.5 64L12.5 32Z" />
  </IconBox>
);
